import amaLog from '../helpers/log';
import waitFor from '../helpers/waitfor';

let jwAdTracked = false;

export const videostats = (reset: boolean = false): any => {
  waitFor(() => typeof window.jwplayer !== 'undefined' && window.jwplayer().on).then(() => {
    amaLog('videoadstats attachListener started');

    const player = window.jwplayer(); 
    
    const onAdRequest = () => {
      if (jwAdTracked && reset === false) return;

      amaLog('JW Player ad requested');

      if (window.ama) {
        window.ama.adStats.add([
          {
            placement: 'preroll',
            gptEvent: 'slotRequested',
          },
        ]);
        window.ama.adStats.push();
        jwAdTracked = true;
      }
    };
    player.on('adRequest', onAdRequest);

  }).catch((error) => {
    amaLog(`videoadstats failed to setup - ${error}`);
  });
};

